// ** React Imports
import { useEffect, useState } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

// ** Context Imports
import { AbilityContext } from 'src/layouts/components/acl/Can'

// ** Config Import
import { buildAbilityFor } from 'src/configs/acl'
import authConfig from 'src/configs/auth'

// ** Component Import
// import NotAuthorized from 'src/pages/401'
import BlankLayout from 'src/@core/layouts/BlankLayout'

// ** React-Redux
import { useSelector } from 'react-redux'

const AclGuard = props => {
  // ** Prop
  const { aclAbilities, children, guestGuard } = props;

  const [ability, setAbility] = useState(undefined);

  // ** Hooks
  const { user } = useSelector((state) => state.auth);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(
    () => {
      // Skip auth check for marketing site routes (CloudFront serves marketing for these)
      // Also skip for /business/login and /business/get-started (auth pages)
      const isMarketingRoute = 
        location.pathname.startsWith('/business') && 
        location.pathname !== '/business/login' && 
        location.pathname !== '/business/get-started';
      
      // PUBLIC ROUTES - Allow access without authentication
      const isPublicRoute = location.pathname === "/home" ||
                           location.pathname === "/" ||
                           location.pathname === "/privacy-policy" ||
                           location.pathname === "/terms-and-conditions" ||
                           location.pathname === "/child-policy" ||
                           location.pathname === "/subscription-terms";

      if (
        !(
          guestGuard ||
          isMarketingRoute ||
          isPublicRoute ||
          location.pathname === "/404" ||
          location.pathname === "/500" ||
          location.pathname === "/login" ||
          location.pathname === "/register" ||
          location.pathname === "/business/login" ||
          location.pathname === "/business/get-started" ||
          location.pathname === "/otp" ||
          location.pathname === "/account/password-reset-request" ||
          location.pathname === "/reset-password"
        )
      ) {
        const currentPath = location.pathname + location.search + location.hash;
        if (
          user === null && !window.localStorage.getItem(authConfig.storageUserDataKeyName)
        ) {
          if (currentPath !== "/") {
            navigate(`/login?redirect=${currentPath}`);
          } else {
            navigate("/login");
          }
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Skip auth check for marketing site routes (CloudFront serves marketing for these)
  // Also skip for /business/login and /business/get-started (auth pages)
  const isMarketingRoute = 
    location.pathname.startsWith('/business') && 
    location.pathname !== '/business/login' && 
    location.pathname !== '/business/get-started';
  
  // PUBLIC ROUTES - Allow access without authentication
  const isPublicRoute = location.pathname === "/home" ||
                       location.pathname === "/" ||
                       location.pathname === "/privacy-policy" ||
                       location.pathname === "/terms-and-conditions" ||
                       location.pathname === "/child-policy" ||
                       location.pathname === "/subscription-terms";

  // If guestGuard is true and user is not logged in or its an error page, render the page without checking access
  if (
    guestGuard ||
    isMarketingRoute ||
    isPublicRoute ||
    location.pathname === "/404" ||
    location.pathname === "/500" ||
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname === "/business/login" ||
    location.pathname === "/business/get-started" ||
    location.pathname === "/otp" ||
    location.pathname === "/account/password-reset-request" ||
    location.pathname === "/reset-password"
  ) {
    return <>{children}</>;
  }

  // User is logged in, build ability for the user based on his role
  if (user && user && !ability) {
    setAbility(buildAbilityFor(user.role, aclAbilities.subject));
  }

  // Check the access of current user and render pages
  if (ability && ability.can(aclAbilities.action, aclAbilities.subject)) {
    return (
      <AbilityContext.Provider value={ability}>
        {children}
      </AbilityContext.Provider>
    );
  }

  // Render Not Authorized component if the current user has limited access
  return <BlankLayout>{/* <NotAuthorized /> */}</BlankLayout>;
}

export default AclGuard
